import { shallowMount } from "@vue/test-utils";
import OfferPanel from "@/components/core/OfferPanel";

describe("OfferPanel component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfferPanel);
  });

  it("Renders del component OfferPanel", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
